import {ItemInsertOptions} from '../EditorTypes';

/**
 * Shared Enter-key behavior for block-selectable NotePart editables (structured/plain tables,
 * captioned attachments, code blocks, fill-in text boxes, note-linked embeddings, image grids, ...).
 *
 * When one of these blocks is selected (its hidden focus editable has focus, as opposed to editing
 * text inside it), pressing Enter inserts a new NotePart below the block, and Shift+Enter inserts one
 * above it. At an entry-day boundary, Shift+Enter should keep the new NotePart on the block's current
 * day rather than defaulting to the previous day (see `insertAtBoundaryStartsNextDay` in
 * `EntryDayOps.adjustDayIndexForReplace`) -- CUST-12203.
 *
 * Every block-type Editable used to hand-roll this `shiftKey ? index - 1 : index` + options logic
 * independently, so the CUST-12203 fix only reached the two implementations it happened to touch
 * (CaptionEditable and TableEditable) and missed the others (CodeEditable, FillInTextBoxEditable,
 * NoteLinkedEmbeddingComponent), and ImageGrid never wired Enter to `insertItemHandler` at all. Block
 * plugins should call this from their Enter key handler instead of reimplementing it, so a future
 * change to this policy only needs to happen once.
 */
export function insertBlockItemOnEnterKey(
  insertItemHandler: (index: number, type?: string | null, options?: ItemInsertOptions) => void,
  index: number,
  e: {shiftKey: boolean},
  type?: string | null
): void {
  const newIndex = e.shiftKey ? index - 1 : index;
  const options: ItemInsertOptions | undefined = e.shiftKey
    ? {insertAtBoundaryStartsNextDay: true}
    : undefined;
  insertItemHandler(newIndex, type, options);
}
